import Api from "./base/api-base";

export default class ConstructionApi {
  // 工事マスタ一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.construction
    });
  }

  // 工事マスタ登録
  // Parameter param オブジェクト
  store(params) {
    return Api.post({
      endpoint: Api.endpoint.construction,
      params: params
    });
  }

  // 工事マスタ情報取得
  // Parameter id 数値型
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.construction,
      id: id
    });
  }

  // 工事マスタ更新
  // Parameter id 数値型 param オブジェクト
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.construction,
      id: id,
      params: params
    });
  }

  // 工事マスタ削除
  // Parameter id 数値型
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.construction,
      id: id
    });
  }

  // 工事マスタ複製
  // Parameter id 数値型
  copy(id) {
    return Api.link.post({
      links: [
        {endpoint: Api.endpoint.construction}, 
        {endpoint: "/copy", id: id},
      ]
    });
  }
}
